angular.module('llax')
    .controller('SupportCtrl', ['$window',
        function($window) {
            $window.location.href = lax_rest_url('support');
        }
    ]);
